// src/lang/index.js

import tr from "./translations/tr";
export default {
  tr,
};